/* components/kitchen/menu/DraftDishesEditor.jsx — редактор stub-блюд при создании меню.
   Список названий будущих блюд (без рецептов); строки можно добавлять/удалять.
   При сохранении нового меню превращаются в stub-позиции (stub_positions).
   ХЕНДОФФ → frontend/src/components/kitchen/menu/DraftDishesEditor.jsx. */

import React from 'react';
import { Button } from '../../ui/Button.jsx';
import { IconButton } from '../../ui/Buttons.jsx';
import { TextInput } from '../../ui/Field.jsx';
import { Icon } from '../../ui/Icon.jsx';

  const { useState } = React;

  function DraftDishesEditor({ value = [], onChange }) {
    const [draft, setDraft] = useState('');
    const add = () => { const t = draft.trim(); if (!t) return; onChange && onChange([...value, t]); setDraft(''); };
    const remove = (i) => onChange && onChange(value.filter((_, idx) => idx !== i));
    const onKey = (e) => { if (e.key === 'Enter') { e.preventDefault(); add(); } };

    return (
      <div className="draft-dishes">
        <p className="t-body-sm text-dim draft-dishes__hint">Добавьте названия будущих блюд — рецепты (ТТК) сгенерируем позже. Можно оставить пустым.</p>
        {value.length > 0 && (
          <ul className="draft-dishes__list">
            {value.map((name, i) => (
              <li key={i} className="draft-dishes__item">
                <Icon name="utensils" size={14} className="text-mute" />
                <span className="grow truncate">{name}</span>
                <span className="badge badge--neutral badge--sm">черновик</span>
                <IconButton icon="close" size="sm" variant="ghost" tooltip="Убрать" onClick={() => remove(i)} />
              </li>
            ))}
          </ul>
        )}
        <div className="draft-dishes__add">
          <TextInput value={draft} placeholder="Например, «Том-ям с креветками»" onChange={(e) => setDraft(e.target.value)} onKeyDown={onKey} />
          <Button variant="secondary" size="sm" iconLeft="plus" onClick={add} disabled={!draft.trim()}>Добавить</Button>
        </div>
      </div>
    );
  }

export { DraftDishesEditor };
